export const CAMERA_PERMISSION_STATES = {
  denied: 'denied',
  granted: 'granted',
  prompt: 'prompt',
  unknown: 'unknown',
  unsupported: 'unsupported',
} as const;

export type CameraPermissionState = (typeof CAMERA_PERMISSION_STATES)[keyof typeof CAMERA_PERMISSION_STATES];

export async function readCameraPermissionState(): Promise<CameraPermissionState> {
  if (!navigator.mediaDevices?.getUserMedia) {
    return CAMERA_PERMISSION_STATES.unsupported;
  }

  if (!navigator.permissions?.query) {
    return CAMERA_PERMISSION_STATES.unknown;
  }

  try {
    const status = await navigator.permissions.query({ name: 'camera' as PermissionName });

    if (
      status.state === CAMERA_PERMISSION_STATES.granted ||
      status.state === CAMERA_PERMISSION_STATES.denied ||
      status.state === CAMERA_PERMISSION_STATES.prompt
    ) {
      return status.state;
    }

    return CAMERA_PERMISSION_STATES.unknown;
  } catch {
    return CAMERA_PERMISSION_STATES.unknown;
  }
}

export function requestEnvironmentCameraStream() {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('Camera access is not available in this browser.');
  }

  return navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      facingMode: {
        ideal: 'environment',
      },
    },
  });
}

export function stopMediaStream(stream: MediaStream | null) {
  for (const track of stream?.getTracks() ?? []) {
    track.stop();
  }
}
